// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__23oPV","buttons":"RemoveExpirationActionButtons_buttons__2IOM2"};